<template>
	<b-container class="show-document" style="width:1200px">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark">
					<i class="fa fa-chevron-left"></i>
					{{ $t('back') }}
				</b-button>
			</div>
			<div class="pull-right">
				<b-button variant="outline-dark" @click="print" class="mr-2">
					<i class="fa fa-print"></i>
					{{ $t('pricing.print') }}
				</b-button>
			</div>
			<div class="clearfix" />
		</div>
		<div class="doc-body">
			<b-card class="p-3" style="min-height:29.7cm; min-width:21cm !important;">
				<b-row>
					<b-col>
						<b><i>DutyFree International</i></b><br>
						<span v-if="$route.params.depId == 'allDeps'">
							<b v-for="(dep, index) in items.companies" :key="`dep-in-${index}`"><ins class="mr-3">{{
								dep.name }}</ins></b>
						</span>
						<span v-else>
							<b v-for="(dep, index) in items.companies" :key="`dep-in-${index}`"><ins
									v-if="$route.params.depId == dep.id" class="mr-3">{{ dep.name }}</ins></b>
						</span>
					</b-col>
					<b-col cols="6">
						<h5>{{ $t('priceAkt.title') }}</h5>
					</b-col>
					<b-col cols="2" />
				</b-row>
				<b-row class="mt-2">
					<b-col>
						<span>{{ $t('priceAkt.commission') }}:</span>
					</b-col>
					<b-col align="center">
						<span>
							<b>№</b> {{ items.costNumber }}
						</span>
						<span>
							<b>{{ $t('priceAkt.from') }}</b> {{ items.costDate }}
						</span>
					</b-col>
					<b-col />
				</b-row>
				<b-row class="mt-5">
					<b-col>
						<span>{{ $t('priceAkt.comment') }}: </span>
						<span>{{ items.comment }}</span>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<b-table :items="computedItems" :fields="columns" :busy="loading" hover striped bordered>
							<template #table-busy>
								<div class="text-center text-primary my-3">
									<b-spinner class="align-middle" />
									<strong class="h4">Loading...</strong>
								</div>
							</template>
							<template slot="thead-top" slot-scope="props">
								<tr>
									<th colspan="6" />
									<th colspan="2" class="text-center">{{ $t('incomes.create.price') }}</th>
									<th />
									<th colspan="2" class="text-center">{{ $t('pos.sum') }}</th>
								</tr>
							</template>
							<template slot="id" slot-scope="data">
								{{ data.index + 1 }}
							</template>
							<template slot="different" slot-scope="data">
								{{ (data.item.priceUzs - data.item.oldPriceUzs).toFixed(4) }}
							</template>
							<template slot="sumOt" slot-scope="data">
								<div v-if="(data.item.remaining * (data.item.priceUzs - data.item.oldPriceUzs)) < 0">
									{{ ((data.item.remaining * (data.item.priceUzs - data.item.oldPriceUzs)) *
										-1).toFixed(4) }}
								</div>
							</template>
							<template slot="sumDo" slot-scope="data">
								<div v-if="(data.item.remaining * (data.item.priceUzs - data.item.oldPriceUzs)) > 0">
									{{ (data.item.remaining * (data.item.priceUzs - data.item.oldPriceUzs)).toFixed(4)
									}}
								</div>
							</template>
							<template slot="bottom-row" slot-scope="data">
								<td v-for="(field, i) in data.fields" class="text-center">
									<b v-if="field.key === 'name'">Итого:</b>
									<b v-if="field.key === 'remaining'">{{ sumRemaining }}</b>
									<b v-if="field.key === 'sumOt'">{{ (sumOt * -1).toFixed(4) }}</b>
									<b v-if="field.key === 'sumDo'">{{ sumDo.toFixed(4) }}</b>
								</td>
							</template>
						</b-table>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col cols="3">
						<b>Акт переоценки на сумму:</b>
					</b-col>
					<b-col>
						<p>{{ number_to_string(Math.abs(sumDo + sumOt * -1)) ? number_to_string(Math.abs(sumDo + sumOt * -1))
							: 0}}</p>
					</b-col>
					<b-col />
				</b-row>
				<b-row class="mt-5">
					<b-col>
						<b>{{ $t('priceAkt.signature') }}:</b>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col>
						<b>1.________________________________________</b>
					</b-col>
					<b-col>
						<b>2.________________________________________</b>
					</b-col>
					<b-col>
						<b>3.________________________________________</b>
					</b-col>
				</b-row>
				<b-row class="mt-4 mb-5">
					<b-col>
						<b>4.________________________________________</b>
					</b-col>
					<b-col>
						<b>5.________________________________________</b>
					</b-col>
					<b-col>
						<b>6.________________________________________</b>
					</b-col>
				</b-row>
			</b-card>
		</div>
	</b-container>
</template>
<script>
import PricesService from "../../../../services/prices.service";
import { TokenService } from "../../../../services/storage.service";

export default {
	name: "pricingNakladnoy",
	data() {
		return {
			items: {},
			loading: false,
			columns: [
				{ key: 'id', label: '№', visible: true, class: 'text-center' },
				{ key: 'barcode', label: this.$t('goods.special-barcode'), class: 'text-center' },
				{ key: 'name', label: this.$t('incomes.create.product'), visible: true },
				{ key: 'termOfItem', label: this.$t('kirim.expirationDate'), class: 'text-center' },
				{ key: 'remaining', label: this.$t('sale.kol-vo'), class: 'text-center' },
				{ key: 'incomeUzs', label: this.$t('prices.item.sum'), class: 'text-center' },
				{ key: 'oldPriceUzs', label: this.$t('priceAkt.before'), class: 'text-center' },
				{ key: 'priceUzs', label: this.$t('priceAkt.after'), class: 'text-center' },
				{ key: 'different', label: 'Разница', class: 'text-center' },
				{ key: 'sumOt', label: this.$t('priceAkt.utsenki'), class: 'text-center' },
				{ key: 'sumDo', label: this.$t('priceAkt.natsenki'), class: 'text-center' },
			]
		}
	},
	methods: {
		goBackToFrom() {
			this.$router.back();
		},
		print() {
			window.print();
		},

		number_to_string(_number) {
			let vm = this;
			var _arr_numbers = new Array();
			_arr_numbers[1] = new Array('',
				vm.$t('number_to_string.1'),
				vm.$t('number_to_string.2'),
				vm.$t('number_to_string.3'),
				vm.$t('number_to_string.4'),
				vm.$t('number_to_string.5'),
				vm.$t('number_to_string.6'),
				vm.$t('number_to_string.7'),
				vm.$t('number_to_string.8'),
				vm.$t('number_to_string.9'),
				vm.$t('number_to_string.10'),
				vm.$t('number_to_string.11'),
				vm.$t('number_to_string.12'),
				vm.$t('number_to_string.13'),
				vm.$t('number_to_string.14'),
				vm.$t('number_to_string.15'),
				vm.$t('number_to_string.16'),
				vm.$t('number_to_string.17'),
				vm.$t('number_to_string.18'),
				vm.$t('number_to_string.19'));

			_arr_numbers[2] = new Array('', '',
				vm.$t('number_to_string.20'),
				vm.$t('number_to_string.30'),
				vm.$t('number_to_string.40'),
				vm.$t('number_to_string.50'),
				vm.$t('number_to_string.60'),
				vm.$t('number_to_string.70'),
				vm.$t('number_to_string.80'),
				vm.$t('number_to_string.90')
			);
			_arr_numbers[3] = new Array('',
				vm.$t('number_to_string.100'),
				vm.$t('number_to_string.200'),
				vm.$t('number_to_string.300'),
				vm.$t('number_to_string.400'),
				vm.$t('number_to_string.500'),
				vm.$t('number_to_string.600'),
				vm.$t('number_to_string.700'),
				vm.$t('number_to_string.800'),
				vm.$t('number_to_string.900'),
			);

			function number_parser(_num, _desc) {
				var _string = '';
				var _num_hundred = '';
				if (_num.length == 3) {
					_num_hundred = _num.substr(0, 1);
					_num = _num.substr(1, 3);
					_string = _arr_numbers[3][_num_hundred] + ' ';
				}
				if (_num < 20) _string += _arr_numbers[1][parseFloat(_num)] + ' ';
				else {
					var _first_num = _num.substr(0, 1);
					var _second_num = _num.substr(1, 2);
					_string += _arr_numbers[2][_first_num] + ' ' + _arr_numbers[1][_second_num] + ' ';
				}
				switch (_desc) {
					case 0:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.eur');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.eur');
						else _string += vm.$t('number_to_string.eur');
						break;
					case 1:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.thousand1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.thousand2');
						else _string += vm.$t('number_to_string.thousand3');
						_string = _string.replace(vm.$t('number_to_string.one1'), vm.$t('number_to_string.one2'));
						_string = _string.replace(vm.$t('number_to_string.two1'), vm.$t('number_to_string.two2'));
						break;
					case 2:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.million1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.million2');
						else _string += vm.$t('number_to_string.million3');
						break;
					case 3:
						var _last_num = parseFloat(_num.substr(-1));
						if (_last_num == 1) _string += vm.$t('number_to_string.billion1');
						else if (_last_num > 1 && _last_num < 5) _string += vm.$t('number_to_string.billion2');
						else _string += vm.$t('number_to_string.billion3');
						break;
				}
				_string = _string.replace('  ', ' ');
				return _string;
			}

			function decimals_parser(_num) {
				var _first_num = _num.substr(0, 1);
				var _second_num = parseFloat(_num.substr(1, 2));
				var _string = ' ' + _first_num + _second_num;
				if (_second_num == 1) _string += vm.$t('number_to_string.cent');
				else if (_second_num > 1 && _second_num < 5) _string += vm.$t('number_to_string.cent');
				else _string += vm.$t('number_to_string.cent');
				return _string;
			}

			if (!_number || _number == 0) return false;
			if (typeof _number !== 'number') {
				_number = _number.replace(',', '.');
				_number = parseFloat(_number);
				if (isNaN(_number)) return false;
			}
			_number = _number.toFixed(2);
			if (_number.indexOf('.') != -1) {
				var _number_arr = _number.split('.');
				var _number = _number_arr[0];
				var _number_decimals = _number_arr[1];
			}
			var _number_length = _number.length;
			var _string = '';
			var _num_parser = '';
			var _count = 0;
			for (var _p = (_number_length - 1); _p >= 0; _p--) {
				var _num_digit = _number.substr(_p, 1);
				_num_parser = _num_digit + _num_parser;

				if ((_num_parser.length == 3 || _p == 0) && !isNaN(parseFloat(_num_parser))) {

					if (_num_parser !== "000") {
						_string = number_parser(_num_parser, _count) + _string;
					}

					_num_parser = '';
					_count++;

				}
			}
			// if (!_string.includes('сум') && !_string.includes('сўм')) {
			// 	_string += this.$t('number_to_string.eur');
			// }

			if (_number_decimals) _string += decimals_parser(_number_decimals);
			return _string.charAt(0).toUpperCase() + _string.slice(1);
		},
	},
	computed: {
		currencyDep() {
			return TokenService.getDepCurrencyName()
		},
		computedItems() {
			let obj = []
			if (this.items.pricingByDifferences)
				this.items.pricingByDifferences.forEach(item => {
					if (this.$route.params.depId == 'allDeps') {
						obj.push(item)
					} else {
						if (this.$route.params.depId == item.departmentId) {
							obj.push(item)
						}
					}
				})
			return obj
		},
		sumRemaining() {
			let sum = 0
			if (this.items.pricingByDifferences)
				this.items.pricingByDifferences.forEach(item => {
					if (this.$route.params.depId == 'allDeps') {
						sum += item.remaining
					} else {
						if (this.$route.params.depId == item.departmentId) {
							sum += item.remaining
						}
					}
				})
			return sum
		},
		sumDo() {
			let sum = 0
			if (this.items.pricingByDifferences)
				this.items.pricingByDifferences.forEach(item => {
					if (this.$route.params.depId == 'allDeps') {
						if ((item.remaining * (item.priceUzs - item.oldPriceUzs)) > 0) {
							sum += (item.remaining * (item.priceUzs - item.oldPriceUzs))
						}
					} else {
						if (this.$route.params.depId == item.departmentId) {
							if ((item.remaining * (item.priceUzs - item.oldPriceUzs)) > 0) {
								sum += (item.remaining * (item.priceUzs - item.oldPriceUzs))
							}
						}
					}
				})
			return sum
		},
		sumOt() {
			let sum = 0
			if (this.items.pricingByDifferences)
				this.items.pricingByDifferences.forEach(item => {
					if (this.$route.params.depId == 'allDeps') {
						if ((item.remaining * (item.priceUzs - item.oldPriceUzs)) < 0) {
							sum += (item.remaining * (item.priceUzs - item.oldPriceUzs))
						}
					} else {
						if (this.$route.params.depId == item.departmentId) {
							if ((item.remaining * (item.priceUzs - item.oldPriceUzs)) < 0) {
								sum += (item.remaining * (item.priceUzs - item.oldPriceUzs))
							}
						}
					}
				})
			return sum
		}
	},
	created() {
		this.loading = true
		PricesService.aktPricingList(this.$route.params.id).then(res => {
			this.items = res.data
			this.loading = false
		}).catch(e => {
			this.loading = false
			this.$vs.notify({
				text: e.response.statusText,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
	}
}
</script>

<style scoped>
@media print {
	.hidden-print {
		display: none;
	}
}

@page {
	margin: 1cm;
}
</style>
